import NFeImport from "@/components/notaFiscal/NotaFiscalImport.vue";

import DashboardLayout from "src/pages/Layout/DashboardLayout.vue";
import AuthLayout from "src/pages/Pages/AuthLayout.vue";
// GeneralViews
import NotFound from "src/pages/GeneralViews/NotFoundPage.vue";

// Calendar
const Calendar = () =>
  import(
    /* webpackChunkName: "extra" */ "src/pages/Calendar/CalendarRoute.vue"
  );
// Charts
const Charts = () =>
  import(/* webpackChunkName: "dashboard" */ "src/pages/Charts.vue");

// Components pages
const Buttons = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/Buttons.vue"
  );
const GridSystem = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/GridSystem.vue"
  );
const Panels = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/Panels.vue"
  );
const SweetAlert = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/SweetAlert.vue"
  );
const Notifications = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/Notifications.vue"
  );
const Icons = () =>
  import(/* webpackChunkName: "components" */ "src/pages/Components/Icons.vue");
const Typography = () =>
  import(
    /* webpackChunkName: "components" */ "src/pages/Components/Typography.vue"
  );

// Dashboard pages
const Dashboard = () =>
  import(
    /* webpackChunkName: "dashboard" */ "src/pages/Dashboard/Dashboard.vue"
  );
import Widgets from "src/pages/Widgets.vue";
import { path } from "d3";

// Forms pages
const RegularForms = () => import("src/pages/Forms/RegularForms.vue");
const ExtendedForms = () => import("src/pages/Forms/ExtendedForms.vue");
const ValidationForms = () => import("src/pages/Forms/ValidationForms.vue");
const Wizard = () => import("src/pages/Forms/Wizard.vue");

// Maps pages
const GoogleMaps = () =>
  import(/* webpackChunkName: "extra" */ "src/pages/Maps/GoogleMaps.vue");
const FullScreenMap = () =>
  import(/* webpackChunkName: "extra" */ "src/pages/Maps/FullScreenMap.vue");
const VectorMaps = () =>
  import(/* webpackChunkName: "extra" */ "src/pages/Maps/VectorMaps.vue");

// Pages
const User = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/UserProfile.vue");
const Pricing = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/Pricing.vue");
const TimeLine = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/TimeLinePage.vue");
const Login = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/Login.vue");
const Register = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/Register.vue");
const RTL = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/RTLPage.vue");
const Lock = () =>
  import(/* webpackChunkName: "pages" */ "src/pages/Pages/Lock.vue");

// TableList pages
const RegularTables = () =>
  import(/* webpackChunkName: "tables" */ "src/pages/Tables/RegularTables.vue");
const ExtendedTables = () =>
  import(
    /* webpackChunkName: "tables" */ "src/pages/Tables/ExtendedTables.vue"
  );
const PaginatedTables = () =>
  import(
    /* webpackChunkName: "tables" */ "src/pages/Tables/PaginatedTables.vue"
  );
let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons }
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: { default: GridSystem }
    },
    {
      path: "panels",
      name: "Panels",
      components: { default: Panels }
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: { default: SweetAlert }
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications }
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons }
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography }
    }
  ]
};

let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: { default: RegularForms }
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: { default: ExtendedForms }
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: { default: ValidationForms }
    },
    {
      path: "wizard",
      name: "Wizard",
      components: { default: Wizard }
    }
  ]
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: { default: RegularTables }
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: { default: ExtendedTables }
    },
    {
      path: "paginated",
      name: "Paginated Tables",
      components: { default: PaginatedTables }
    }
  ]
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: { default: GoogleMaps }
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      meta: {
        hideContent: true,
        hideFooter: true
      },
      components: { default: FullScreenMap }
    },
    {
      path: "vector-map",
      name: "Vector Map",
      components: { default: VectorMaps }
    }
  ]
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      components: { default: User }
    },
    {
      path: "timeline",
      name: "Timeline Page",
      components: { default: TimeLine }
    },
    {
      path: "rtl",
      name: "RTL Page",
      components: { default: RTL }
    },

    {
      path: "/old/login",
      name: "Old login",
      component: () => import("@/components/auth/login.vue")
    },
    {
      path: "/register",
      name: "Old register",
      component: () => import("@/components/auth/register.vue")
    },
    {
      path: "/secure",
      name: "secure",
      component: () => import("@/components/auth/secure.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/hello",
      name: "HelloWorld",
      component: () => import("@/components/HelloWorld.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/prazoEntregaPaises",
      name: "PrazoEntregaPaises",
      component: () =>
        import("@/components/rotaPrazoEntrega/PrazoEntregaPaises.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/user/create",
      name: "CreateUser",
      component: () => import("@/components/user/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/entrega/list",
      name: "Entregas",
      component: () => import("@/components/entrega/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/entrega/comprovante",
      name: "Comprovante de Entrega",
      component: () => import("@/pages/Entregas/Comprovante.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/entregaOcorrencia/list/:id",
      name: "Ocorrências entrega",
      props: true,
      component: () => import("@/components/entregaOcorrencia/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/entregaOcorrencia/import",
      name: "Importação de EDI",
      component: () => import("@/components/entregaOcorrencia/Import.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/rotaPrazoEntrega/edit",
      name: "EditRegiaoPrazoEntrega",
      component: () => import("@/components/rotaPrazoEntrega/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/rotaPrazoEntrega/editTransportador",
      name: "Prazos de Entrega",
      component: () =>
        import("@/components/rotaPrazoEntrega/EditTransportador.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/rotaPrazoEntrega/editMultiple",
      name: "EditMultipleRegiaoPrazoEntrega",
      component: () => import("@/components/rotaPrazoEntrega/EditMultiple.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/rotaPrazoEntrega/list",
      name: "ListRegiaoPrazoEntrega",
      component: () => import("@/components/rotaPrazoEntrega/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    // ivan 20200702
    // {
    //     path: '/rotaPrazoEntrega/prazoEntregaPaises',
    //     name: 'PrazoEntregaPaises',
    //     component: () => import('@/components/rotaPrazoEntrega/PrazoEntregaPaises.vue'),
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    {
      path: "/usuario/create/",
      name: "CreateUsuario",
      component: () => import("@/components/usuario/Create.vue")
    },
    {
      path: "/usuario/edit/:id/",
      name: "EditUsuario",
      props: true,
      component: () => import("@/components/usuario/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/usuario/list",
      name: "ListUsuario",
      component: () => import("@/components/usuario/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/notaFiscal/import",
      name: "Importação de NF-e",
      component: NFeImport, // () => import('@/components/notaFiscal/NotaFiscalImport.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/notaFiscal/importStatus/:id",
      name: "NFeImportStatus",
      props: true,
      component: () => import("@/components/notaFiscal/NFeImportStatus.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/notaFiscal/importLog/:id/:lastRefresh",
      name: "NFeImportDefails",
      props: true,
      component: () => import("@/components/notaFiscal/NFeImportDetails.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/cte/import",
      name: "Importação de CT-e",
      component: () => import("@/components/cte/CteImport.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/tabelaOcorrenciaDePara/list",
      name: "Ocorrências de/para",
      component: () => import("@/components/tabelaOcorrenciaDePara/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/tabelaOcorrenciaDePara/deParaEmbarcador",
      name: "Ocorrências de/para",
      component: () =>
        import("@/components/tabelaOcorrenciaDePara/DeParaEmbarcadores.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/tabelaOcorrenciaProceda/list",
      name: "ListTabelaOcorrenciaProceda",
      component: () => import("@/components/tabelaOcorrenciaProceda/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/filterTable/complete",
      name: "FilterTableComplete",
      component: () => import("@/components/filterTable/Complete.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/filterTable/justFilter",
      name: "FilterTableJustFilter",
      component: () => import("@/components/filterTable/JustFilter.vue"),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

let empresa = {
  path: "/empresa",
  name: "Empresa",
  component: DashboardLayout,
  children: [
    {
      path: "",
      redirect: "/list"
    },
    {
      path: "bi/:companyId",
      name: "Visualizações BI",
      props: true,
      component: () => import("@/pagesRms/BI/PowerBIView/PowerBIViewList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "bicreate/:companyId",
      name: "Criar BI",
      props: true,
      component: () =>
        import("@/pagesRms/BI/PowerBIView/PowerBIViewCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "biedit/:id/:companyId",
      name: "Criar BI",
      props: true,
      component: () => import("@/pagesRms/BI/PowerBIView/PowerBIViewEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "create",
      name: "Criar empresa",
      component: () => import("@/components/empresa/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "edit/:id",
      name: "Editar empresa",
      props: true,
      component: () => import("@/components/empresa/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "list",
      name: "Empresas",
      component: () => import("@/components/empresa/List.vue"),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

let newAuthPages = {
  path: "/",
  component: () => import("@/pagesRms/Authentication/Layout.vue"),
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "login",
      component: () => import("@/pagesRms/Authentication/Login.vue")
    },
    {
      path: "/user/passwordReset/:userId",
      name: "Alterar senha",
      props: true,
      component: () => import("@/pagesRms/System/User/UserChangePassword.vue")
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Vuejsblackdashboard Authentication",
  children: [
    {
      path: "/vuejsblackdashboard/login",
      name: "Vuejsblackdashboard Login",
      component: Login
    },
    {
      path: "/register",
      name: "Vuejsblackdashboard Register",
      component: Register
    },
    {
      path: "/pricing",
      name: "Vuejsblackdashboard Pricing",
      component: Pricing
    },
    {
      path: "/lock",
      name: "Vuejsblackdashboard Lock",
      component: Lock
    }
  ]
};

const ModuleLayout = () =>
  import("src/pagesRms/System/Module/ModuleDashboard.vue");

let pagesRmsModule = {
  path: "/modulo/layout/",
  component: ModuleLayout,
  name: "MóduloLayout",
  props: true,
  children: [
    {
      path: "/modulo/:moduleId/:id?",
      name: "Módulo",
      props: true,
      component: () => import("@/pagesRms/System/Module/ModuleView.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/forms/:moduleId",
      name: "Formulários",
      props: true,
      component: () => import("@/pagesRms/System/Module/ModuleFormList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/fillForm/:moduleId/:id",
      name: "PREENCHIMENTO DE FORMULÁRIO",
      props: true,
      component: () => import("@/pagesRms/System/Module/ModuleFillForm.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/layout/draft/:moduleId/:id",
      name: "Rascunhos",
      props: true,
      component: () => import("@/pagesRms/System/Module/ModuleFormDraft.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/layout/draft/:moduleId/:FormId/:ChecklistId?",
      name: "Preenchimento de Formulário",
      component: () =>
        import("src/pagesRms/checklist/checklist/ChecklistFill.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/form/details/:moduleId/:id/:itemId",
      name: "Detalhes do Preenchimento",
      component: () =>
        import("src/pagesRms/System/Module/ModuleDetailedForm.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/Layout/form/Create/:moduleId",
      name: "Criar Formulários",
      component: () => import("src/pagesRms/checklist/form/Create.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/pendencies/PedenciesDetails/:id/:moduleId",
      name: "Detalhes da Pendência",
      component: () =>
        import(
          "src/pagesRms/System/Module/Pendencies/ModulePendenciesDetails.vue"
        ),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/pendencies/approved/:moduleId",
      name: "Pendências aprovadas",
      component: () =>
        import("src/pagesRms/System/Module/Pendencies/ModulePendencies.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/pendencies/disapproved/:moduleId",
      name: "Pendencias reprovadas",
      component: () =>
        import(
          "src/pagesRms/System/Module/Pendencies/ModulePendenciesDisapproved.vue"
        ),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/pendencies/expired/:moduleId",
      name: "Pendências expiradas",
      component: () =>
        import(
          "src/pagesRms/System/Module/Pendencies/ModulePendenciesExpired.vue"
        ),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/pendencies/opened/:moduleId",
      name: "Pendências em aberto",
      component: () =>
        import(
          "src/pagesRms/System/Module/Pendencies/ModulePendenciesOpened.vue"
        ),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/module/bi/:moduleId",
      name: "BI",
      props: true,
      component: () => import("@/pagesRms/System/Module/ModuleBiList.vue"),
      meta: {
        requiresAuth: true
      }
    }
  ]
};
const WorkflowLayout = () => import("src/pagesRms/Workflow/WorkflowLayout.vue");
let pagesRmsWorkflow = {
  path: "/worflow/layout/",
  component: WorkflowLayout,
  name: "Workflow",
  props: true,
  children: [
    {
      path: "/workflow/user/list",
      name: "Usuários",
      component: () => import("@/components/usuario/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/user/create/",
      name: "Criar usuário",
      component: () => import("@/components/usuario/Create.vue")
    },
    {
      path: "/workflow/user/edit/:id/",
      name: "Editar usuário",
      props: true,
      component: () => import("@/components/usuario/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/user/importUser/",
      name: "Importar usuários",
      component: () => import("@/components/usuario/ImportUser.vue")
    },
    {
      path: "/workflow/profile/all",
      name: "Perfils",
      component: () => import("src/pagesRms/System/Profile/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/profile/create",
      name: "Criar Perfil",
      component: () => import("@/pagesRms/System/Profile/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/profile/edit/:id",
      name: "Editar Perfil",
      props: true,
      component: () => import("@/pagesRms/System/Profile/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/module/all",
      name: "Módulos",
      component: () => import("src/pagesRms/System/Module/ModuleList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/module/create",
      name: "Criar Módulo",
      component: () => import("@/pagesRms/System/Module/ModuleCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/module/edit/:id",
      name: "Editar Módulo",
      props: true,
      component: () => import("@/pagesRms/System/Module/ModuleEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/moduleProfile/list/:id",
      name: "Perfis do módulo",
      props: true,
      component: () =>
        import("src/pagesRms/System/Module/ModuleProfileList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/company/all",
      name: "Empresas",
      component: () => import("@/components/empresa/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/company/create",
      name: "Criar empresa",
      component: () => import("@/components/empresa/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/company/edit/:id",
      name: "Editar empresa",
      props: true,
      component: () => import("@/components/empresa/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/Create/:idBase?",
      name: "Criação de Processos",
      props: true,
      component: () => import("@/pagesRms/Workflow/Process/ProcessCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/dynamicSearches/:processId",
      name: "Buscas dinâmicas",
      props: true,
      component: () =>
        import("@/pagesRms/dynamicSearches/DynamicSearchesList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/processList",
      name: "Lista de Processos",
      props: true,
      component: () => import("@/pagesRms/Workflow/Process/ProcessList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/process/edit/:id",
      name: "Editar Processo",
      props: true,
      component: () => import("@/pagesRms/Workflow/Process/ProcessEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/process/fill/:id",
      name: "Preencher Processo",
      props: true,
      component: () => import("@/pagesRms/Workflow/WorkflowFill.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/process/filled/list",
      name: "Processos Preenchidos",
      props: true,
      component: () =>
        import("@/pagesRms/Workflow/Process/ProcessFilledList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/filled/:processName/:processId",
      name: "Processos Preenchidos",
      props: true,
      component: () => import("@/pagesRms/Workflow/WorkflowFilled.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/filled/import/:processName/:processId",
      name: "Importar processos",
      props: true,
      component: () =>
        import("@/components_rms/workflow/WorkflowImportPage.vue"),
      meta: {
        requiresAuth: true
      }
    },
    // shlog - Status viagem
    {
      path: "/shlog/tripStatus/",
      name: "Status das Viagens",
      component: () =>
        import("@/pages_custom/shlog/workflow/ShlogTripStatusList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    // shlog - Status frota
    {
      path: "/shlog/fleet/status/list",
      name: "Status da Frota",
      component: () =>
        import("@/pages_custom/shlog/workflow/ShlogFleetStatus.vue"),
      meta: {
        requiresAuth: true
      }
    },
    // shlog - Status viagem
    {
      path: "/shlog/monitoramentoLogistico/",
      name: "Monitoramento Logístico",
      component: () =>
        import("@/pages_custom/shlog/workflow/ShLogMonitoramentoLogistico.vue"),
      meta: {
        requiresAuth: true
      }
    },
    //shLog - Preenchidos
    {
      path: "/workflow/filled/shlog/:processName/:processId",
      name: "Processos Preenchidos",
      props: true,
      component: () =>
        import("@/pages_custom/shlog/workflow/ShlogProcessFilledList.vue"),
      // component: () => import('@/pagesRms/Workflow/Process/Filled/ProcessFilled.vue'),
      meta: {
        requiresAuth: true
      }
    },
    // shlog - Status frota
    {
      path: "/shlog/freteRapido/solicitacaoColeta/nfe/",
      name: "NF-e das solicitações de coleta",
      component: () =>
        import(
          "@/pages_custom/shlog/ShLogFreteRapidoSolicitacoesColetaNFe.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/process/filledDetail/:id/:processName?/:processId?",
      name: "Processo",
      props: true,
      component: () =>
        import("@/pagesRms/Workflow/Process/ProcessFilledDetail.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/kanban/:name/:id?",
      name: "WorkflowKanbanPage",
      props: true,
      component: () =>
        import("@/pagesRms/Workflow/Kanban/WorkflowKanbanPage.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/pathList",
      name: "Trajeto",
      props: true,
      component: () => import("@/pagesRms/Workflow/Path/ProcessPathList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/pathCreate/:id?",
      name: "Criar Trajeto",
      props: true,
      component: () => import("@/pagesRms/Workflow/Path/ProcessPathCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/pathEdit/:id",
      name: "Criar Trajeto",
      props: true,
      component: () => import("@/pagesRms/Workflow/Path/ProcessPathEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/waypointList",
      name: "Pontos de paradas",
      props: true,
      component: () => import("@/pagesRms/Workflow/Waypoint/WaypointList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/waypointEdit/:id",
      name: "Pontos de paradas",
      props: true,
      component: () => import("@/pagesRms/Workflow/Waypoint/WaypointEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/waypointCreate",
      name: "Pontos de paradas",
      props: true,
      component: () =>
        import("@/pagesRms/Workflow/Waypoint/WaypointCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/systemIntegrationCompany/all/:empresaId",
      name: "Integrações da empresa",
      props: true,
      component: () =>
        import("src/pagesRms/System/SystemIntegrationCompany/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path:
        "/workflow/systemIntegrationCompany/List/:empresaId/:itegrationCompanyId",
      name: "Conexões da empresa",
      props: true,
      component: () =>
        import(
          "src/pagesRms/System/SystemIntegrationCompany/ListConnections.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path:
        "/workflow/systemIntegrationCompany/edit/:id/:empresaId/:itegrationCompanyId",
      name: "Editar conexões",
      props: true,
      component: () =>
        import(
          "src/pagesRms/System/SystemIntegrationCompany/EditConnections.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path:
        "/workflow/systemIntegrationCompany/createIntegration/:empresaId/:itegrationCompanyId",
      name: "Criar conexão",
      props: true,
      component: () =>
        import(
          "src/pagesRms/System/SystemIntegrationCompany/CreateIntegration.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path:
        "/workflow/systemIntegrationCompany/edit/:id/:empresaId/:itegrationCompanyId",
      name: "Editar conexões",
      props: true,
      component: () =>
        import(
          "src/pagesRms/System/SystemIntegrationCompany/EditConnections.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/systemIntegration/all",
      name: "Integrações",
      props: true,
      component: () => import("src/pagesRms/System/SystemIntegration/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/systemIntegration/create",
      name: "Criar Integração",
      component: () => import("@/pagesRms/System/SystemIntegration/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/systemIntegration/edit/:id",
      name: "Editar integração",
      props: true,
      component: () => import("@/pagesRms/System/SystemIntegration/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/systemFieldType/all/:systemIntegrationId",
      name: "Tipos de campo",
      props: true,
      component: () => import("src/pagesRms/System/SystemFieldType/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/systemFieldType/create/:systemIntegrationId",
      name: "Criar tipo de campo",
      props: true,
      component: () => import("@/pagesRms/System/SystemFieldType/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/systemFieldType/edit/:id",
      name: "Edição tipo de campo",
      props: true,
      component: () => import("@/pagesRms/System/SystemFieldType/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/fuelConsumptionTarget/list/",
      name: "Listagem de metas de comsbustível",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelConsumptionTarget/FuelConsumptionTargetList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/fuelConsumptionTarget/create/",
      name: "Criação de metas de comsbustível",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelConsumptionTarget/FuelConsumptionTargetCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/fuelConsumptionTarget/edit/:id",
      name: "Edição de metas de comsbustível",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelConsumptionTarget/FuelConsumptionTargetEdit.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/fuelStock/create",
      name: "Criação de movimento de estoque de combustível",
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelStock/FuelStockCreateMovement.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/fuelStock/list",
      name: "Lista de estoque de combustível",
      component: () =>
        import("src/pagesRms/fuelSupplies/fuelStock/FuelStockList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/fuelStock/movements/list/:fuelTypeId",
      name: "Movimentações estoque de combustível",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelStockMovements/FuelStockMovementList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path:
        "/workflow/fuelStock/movements/list/:fuelTypeId/:internalGasStation",
      name: "Movimentações estoque de combustível",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelStockMovements/FuelStockMovementList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/gasStation/list/",
      name: "Listagem de postos de gasolina",
      props: true,
      component: () =>
        import("src/pagesRms/fuelSupplies/gasStation/GasStationList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/gasStation/create/",
      name: "Criação de postos de gasolina",
      props: true,
      component: () =>
        import("src/pagesRms/fuelSupplies/gasStation/GasStationCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/gasStation/edit/:id",
      name: "Edição de postos de gasolina",
      props: true,
      component: () =>
        import("src/pagesRms/fuelSupplies/gasStation/GasStationEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/vehicleRegistration/list/",
      name: "Listagem de equipamentos",
      props: true,
      component: () =>
        import("src/pagesRms/Vehicles/VehicleRegistration/VehicleList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/vehicleRegistration/create/",
      name: "Criação de equipamentos",
      props: true,
      component: () =>
        import("src/pagesRms/Vehicles/VehicleRegistration/VehicleCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/vehicleRegistration/edit/:id",
      name: "Edição de equipamentos",
      props: true,
      component: () =>
        import("src/pagesRms/Vehicles/VehicleRegistration/VehicleEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/vehicleRegistration/import",
      name: "Importar usuários",
      component: () =>
        import("@/pagesRms/Vehicles/VehicleRegistration/VehicleImport.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/vehicleType/list",
      name: "Modelo de veículos",
      component: () =>
        import("@/pagesRms/Vehicles/VehicleType/VehicleTypeList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/sector/all",
      name: "Setor",
      component: () => import("@/pagesRms/System/Sector/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/sector/create",
      name: "Registrar setor",
      props: true,
      component: () => import("@/pagesRms/System/Sector/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/sector/edit/:id",
      name: "Editar setor",
      props: true,
      component: () => import("@/pagesRms/System/Sector/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/costCenter/list/",
      name: "centro de custo",
      component: () =>
        import("@/pagesRms/System/CostCenter/CostCenterList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/costCenter/create/",
      name: "centro de custo",
      component: () =>
        import("@/pagesRms/System/CostCenter/CostCenterCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/costCenter/edit/:id",
      name: "centro de custo",
      component: () =>
        import("@/pagesRms/System/CostCenter/CostCenterEdit.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/brandVehicle/list",
      name: "Marca de veículos",
      component: () =>
        import("@/pagesRms/System/BrandVehicle/BrandVehicleList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/brandVehicle/create/",
      name: "Marca de veículos",
      component: () =>
        import("@/pagesRms/System/BrandVehicle/BrandVehicleCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/brandVehicle/edit/:id",
      name: "Marca de veículos",
      component: () =>
        import("@/pagesRms/System/BrandVehicle/BrandVehicleEdit.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/vehicleModel/list",
      name: "Modelo de veículos",
      component: () =>
        import("@/pagesRms/System/VehicleModel/VehicleModelList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/vehicleModel/create/",
      name: "Modelo de veículos",
      component: () =>
        import("@/pagesRms/System/VehicleModel/VehicleModelCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/vehicleModel/edit/:id",
      name: "Modelo de veículos",
      component: () =>
        import("@/pagesRms/System/VehicleModel/VehicleModelEdit.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/vehicleAvailableReason/list",
      name: "Motivo de desativação",
      component: () =>
        import(
          "@/pagesRms/Vehicles/VehicleAvailableReason/VehicleAvailableReasonList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/vehicleAvailableReason/create",
      name: "Motivo de desativação",
      component: () =>
        import(
          "@/pagesRms/Vehicles/VehicleAvailableReason/VehicleAvailableReasonCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/vehicleAvailableReason/edit/:id",
      name: "Motivo de desativação",
      component: () =>
        import(
          "@/pagesRms/Vehicles/VehicleAvailableReason/VehicleAvailableReasonEdit.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/sector/all",
      name: "Setor",
      component: () => import("@/pagesRms/System/Sector/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/sector/create",
      name: "Registrar setor",
      props: true,
      component: () => import("@/pagesRms/System/Sector/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/sector/edit/:id",
      name: "Editar setor",
      props: true,
      component: () => import("@/pagesRms/System/Sector/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

const BiLayout = () => import("src/pagesRms/BI/Layout/BiLayout.vue");

let pagesRmsBI = {
  path: "/bi/Layout/",
  component: BiLayout,
  name: "BiLayout",
  children: [
    {
      path: "/bi/dashboard/default",
      name: "Dashboard",
      component: () => import("src/pagesRms/checklist/Dashboard/Dashboard.vue")
    },
    {
      path: "/bi/:id?",
      name: "Painel BI",
      props: true,
      component: () =>
        import("@/pagesRms/BI/PowerBIView/PowerBiViewDisplay.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/bi/user/profile/",
      name: "ChecklistUserProfile",
      props: true,
      component: () => import("@/pagesRms/System/User/UserProfile.vue"),
      meta: {
        title: "Perfil do usuário",
        requiresAuth: true
      }
    },

    {
      path: "/bi/user/profileEdit/",
      name: "ChecklistUserProfileEdit",
      props: true,
      component: () => import("@/pagesRms/System/User/UserProfileEdit.vue"),
      meta: {
        title: "Editar perfil do usuário",
        requiresAuth: true
      }
    },
    {
      path: "/bi/user/changePassword/",
      name: "ChecklistUserProfileChangePassword",
      props: true,
      component: () =>
        import("@/pagesRms/System/User/UserProfileEditPassword.vue"),
      meta: {
        title: "Alterar senha",
        requiresAuth: true
      }
    },
    {
      path: "/bi/company/edit/:id",
      name: "Editar empresa",
      props: true,
      component: () => import("@/components/empresa/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/bi/user/importUser/",
      name: "Importar usuários",
      component: () => import("@/components/usuario/ImportUser.vue")
      // meta: {
      //   requiresAuth: true
      // }
    },
    {
      path: "/bi/module/all",
      name: "Módulos",
      component: () => import("src/pagesRms/System/Module/ModuleList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/bi/module/create",
      name: "Criar Módulo",
      component: () => import("@/pagesRms/System/Module/ModuleCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/bi/module/edit/:id",
      name: "Editar Módulo",
      props: true,
      component: () => import("@/pagesRms/System/Module/ModuleEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/bi/moduleProfile/list/:id",
      name: "Perfis do módulo",
      props: true,
      component: () =>
        import("src/pagesRms/System/Module/ModuleProfileList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/bi/moduleMenu/list/:id",
      name: "Menu do módulo",
      props: true,
      component: () => import("src/pagesRms/System/Module/ModuleMenuList.vue"),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

const Checklist = () =>
  import("src/pagesRms/checklist/Layout/checklistLayout.vue");
const ChecklistCustom = () => import("src/pagesRms/checklist/form/Custom.vue");
const ChecklistCreate = () => import("src/pagesRms/checklist/form/Create.vue");
const ChecklistOwn = () => import("src/pagesRms/checklist/form/Own.vue");
const ChecklistShared = () => import("src/pagesRms/checklist/form/Shared.vue");
const ChecklistFill = () =>
  import("src/pagesRms/checklist/checklist/ChecklistFill.vue");
const ChecklistFilled = () =>
  import("src/pagesRms/checklist/checklist/ChecklistFilledList.vue");
const EditForm = () => import("src/pagesRms/checklist/form/EditForm.vue");

let pagesChecklistRMS = {
  path: "/checklist/Layout/",
  component: Checklist,
  name: "ChecklistLayout",
  children: [
    {
      path: "/camera",
      name: "camera",
      component: () => import("@/components_rms/Camera.vue")
    },
    {
      path: "/checklist/support/chat",
      name: "Support chat",
      component: () => import("src/pagesRms/support/SupportChat.vue")
    },
    {
      path: "/checklist/dashboard/default",
      name: "Dashboard",
      component: () => import("src/pagesRms/checklist/Dashboard/Dashboard.vue")
    },
    {
      path: "/checklist/Layout/form/Create/:idBase?",
      name: "Criar Formulários",
      component: ChecklistCreate,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/Layout/form/Own/",
      name: "Formulários Próprios",
      component: ChecklistOwn,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/Layout/form/Shared",
      name: "Formulários Compartilhados",
      component: ChecklistShared,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/Layout/form/fill/:FormId/:ChecklistId?",
      name: "Preenchimento de Formulário",
      component: ChecklistFill,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/Layout/form/Filled",
      name: "Formulários Preenchidos",
      component: ChecklistFilled,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/pending",
      name: "Formulários pendentes",
      component: () =>
        import("src/pagesRms/checklist/checklist/ChecklistListPending.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/typing",
      name: "Formulários em digitação",
      component: () =>
        import("src/pagesRms/checklist/checklist/ChecklistListTyping.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/form/filled/details/:id",
      name: "Detalhes do Preenchimento",
      component: () =>
        import("src/pagesRms/checklist/checklist/ChecklistFilledDatails.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/Layout/form/EditForm/:id",
      name: "Editar Formulários",
      component: EditForm,
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/user/list/",
      name: "Usuários",
      component: () => import("@/components/usuario/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/user/create/",
      name: "Criar usuário",
      component: () => import("@/components/usuario/Create.vue")
    },
    {
      path: "/checklist/user/edit/:id/",
      name: "Editar usuário",
      props: true,
      component: () => import("@/components/usuario/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/user/importUser/",
      name: "Importar usuários",
      component: () => import("@/components/usuario/ImportUser.vue")
    },
    {
      path: "/checklist/user/profile/",
      name: "ChecklistUserProfile",
      props: true,
      component: () => import("@/pagesRms/System/User/UserProfile.vue"),
      meta: {
        title: "Perfil do usuário",
        requiresAuth: true
      }
    },
    {
      path: "/checklist/user/profileEdit/",
      name: "ChecklistUserProfileEdit",
      props: true,
      component: () => import("@/pagesRms/System/User/UserProfileEdit.vue"),
      meta: {
        title: "Editar perfil do usuário",
        requiresAuth: true
      }
    },
    {
      path: "/checklist/user/changePassword/",
      name: "ChecklistUserProfileChangePassword",
      props: true,
      component: () =>
        import("@/pagesRms/System/User/UserProfileEditPassword.vue"),
      meta: {
        title: "Alterar senha",
        requiresAuth: true
      }
    },

    {
      path: "/checklist/Layout/form/Draft",
      name: "Rascunhos",
      props: true,
      component: () => import("src/pagesRms/checklist/form/Draft.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/Layout/form/Pendencies",
      name: "Pendências",
      props: true,
      component: () =>
        import("src/pagesRms/checklist/pendency/PendenciesApproved.vue"),
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/checklist/Layout/form/PedenciesDetails/:id",
      name: "Detalhes Pendências",
      props: true,
      component: () =>
        import("src/pagesRms/checklist/pendency/PendenciesDetails.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/pendencies/approved",
      name: "Pendências",
      props: true,
      component: () =>
        import("src/pagesRms/checklist/pendency/PendenciesApproved.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/pendencies/disapproved",
      name: "Pendencias reprovadas",
      props: true,
      component: () =>
        import("src/pagesRms/checklist/pendency/PendenciesDisapproved.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/pendencies/expired",
      name: "Pendências",
      props: true,
      component: () =>
        import("src/pagesRms/checklist/pendency/PendenciesExpired.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/pendencies/opened",
      name: "Pendências",
      props: true,
      component: () =>
        import("src/pagesRms/checklist/pendency/PendenciesOpened.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/profile/all",
      name: "Perfis",
      component: () => import("src/pagesRms/System/Profile/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/workflow/profile/profileRelease/:id/:name",
      name: "liberações do perfil",
      component: () =>
        import(
          "src/components_rms/System/Profile/ChecklistProfileRelease/ChekclistProfileRelease.vue"
        ),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/profile/profileRelease/:id/:name",
      name: "liberações do perfil",
      component: () =>
        import(
          "src/components_rms/System/Profile/ChecklistProfileRelease/ChekclistProfileRelease.vue"
        ),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/profile/create",
      name: "Criar Perfil",
      component: () => import("@/pagesRms/System/Profile/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/profile/edit/:id",
      name: "Editar Perfil",
      props: true,
      component: () => import("@/pagesRms/System/Profile/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/scheduler/create/:formId",
      name: "Agendamento checklist",
      props: true,
      component: () =>
        import("@/components_rms/checklist/scheduler/FormScheduler.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/scheduler/edit/:schedulerId",
      name: "Agendamento checklist",
      props: true,
      component: () =>
        import("@/components_rms/checklist/scheduler/FormScheduler.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/scheduler/forms",
      name: "Agendamento checklist",
      props: true,
      component: () =>
        import("@/pagesRms/checklist/Scheduler/FormSchedulerList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/schedules/",
      name: "Agendamentos",
      props: true,
      component: () =>
        import("@/pagesRms/checklist/Scheduler/FormSchedules.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/user/change/:checklistId",
      name: "Alteração de responsabilidade",
      props: true,
      component: () =>
        import("@/pagesRms/checklist/checklist/ChecklistUserChange.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/scheduler/",
      name: "Agendamento checklist",
      props: true,
      component: () => import("@/components_rms/scheduler/Scheduler.vue"),
      meta: {
        requiresAuth: true
      }
    },
    // { // ivan rota retirada
    //   path: '/checklist/scheduler/create/:formId',
    //   name: 'Agendamento checklist',
    //   props: true,
    //   component: () => import('@/pagesRms/checklist/Scheduler/ChecklistScheduler.vue'),
    //   meta: {
    //     requiresAuth: true
    //   }
    // },
    {
      path: "/checklist/scheduler/formFill/:ChecklistId",
      name: "Preenchimento checklist",
      props: true,
      component: () =>
        import("@/pagesRms/checklist/Scheduler/FormSchedulerFill.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/Layout/form/Own/",
      name: "Formulários Próprios",
      component: ChecklistOwn,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/systemIntegration/all",
      name: "Integrações",
      props: true,
      component: () => import("src/pagesRms/System/SystemIntegration/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/systemIntegration/create",
      name: "Criar Integração",
      component: () => import("@/pagesRms/System/SystemIntegration/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/systemIntegration/edit/:id",
      name: "Editar integração",
      props: true,
      component: () => import("@/pagesRms/System/SystemIntegration/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/systemIntegrationCompany/all/:empresaId",
      name: "Integrações da empresa",
      props: true,
      component: () =>
        import("src/pagesRms/System/SystemIntegrationCompany/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path:
        "/checklist/systemIntegrationCompany/createIntegration/:empresaId/:itegrationCompanyId",
      name: "Criar conexão",
      props: true,
      component: () =>
        import(
          "src/pagesRms/System/SystemIntegrationCompany/CreateIntegration.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path:
        "/checklist/systemIntegrationCompany/List/:empresaId/:itegrationCompanyId",
      name: "Conexões da empresa",
      props: true,
      component: () =>
        import(
          "src/pagesRms/System/SystemIntegrationCompany/ListConnections.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path:
        "/checklist/systemIntegrationCompany/edit/:id/:empresaId/:itegrationCompanyId",
      name: "Editar conexões",
      props: true,
      component: () =>
        import(
          "src/pagesRms/System/SystemIntegrationCompany/EditConnections.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/company/list",
      name: "Empresas",
      component: () => import("@/components/empresa/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/company/create",
      name: "Criar empresa",
      component: () => import("@/components/empresa/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/company/edit/:id",
      name: "Editar empresa",
      props: true,
      component: () => import("@/components/empresa/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/systemFieldType/all/:systemIntegrationId",
      name: "Tipos de campo",
      props: true,
      component: () => import("src/pagesRms/System/SystemFieldType/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/systemFieldType/create/:systemIntegrationId",
      name: "Criar tipo de campo",
      props: true,
      component: () => import("@/pagesRms/System/SystemFieldType/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/systemFieldType/edit/:id",
      name: "Edição tipo de campo",
      props: true,
      component: () => import("@/pagesRms/System/SystemFieldType/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/cloningForm/",
      name: "Clonar Formulário",
      props: true,
      component: () =>
        import("@/components_rms/checklist/cloningForm/CloningForm.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/company/bi/:companyId",
      name: "Visualizações BI",
      props: true,
      component: () => import("@/pagesRms/BI/PowerBIView/PowerBIViewList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/company/bicreate/:companyId",
      name: "Criar BI",
      props: true,
      component: () =>
        import("@/pagesRms/BI/PowerBIView/PowerBIViewCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/company/biedit/:id/:companyId",
      name: "Criar BI",
      props: true,
      component: () => import("@/pagesRms/BI/PowerBIView/PowerBIViewEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/module/all",
      name: "Módulos",
      component: () => import("src/pagesRms/System/Module/ModuleList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/module/create",
      name: "Criar Módulo",
      component: () => import("@/pagesRms/System/Module/ModuleCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/module/edit/:id",
      name: "Editar Módulo",
      props: true,
      component: () => import("@/pagesRms/System/Module/ModuleEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/moduleProfile/list/:id",
      name: "Perfis do módulo",
      props: true,
      component: () =>
        import("src/pagesRms/System/Module/ModuleProfileList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/moduleMenu/list/:id",
      name: "Menu do módulo",
      props: true,
      component: () => import("src/pagesRms/System/Module/ModuleMenuList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/fuelSupply/list/",
      name: "Listagem abastecimentos",
      props: true,
      component: () =>
        import("src/pagesRms/fuelSupplies/fuelSupplies/FuelSupplyList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/fuelConsumptionTarget/list/",
      name: "Listagem de metas de comsbustível",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelConsumptionTarget/FuelConsumptionTargetList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/fuelConsumptionTarget/create/",
      name: "Criação de metas de comsbustível",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelConsumptionTarget/FuelConsumptionTargetCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/fuelConsumptionTarget/edit/:id",
      name: "Edição de metas de comsbustível",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelConsumptionTarget/FuelConsumptionTargetEdit.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/fuelStock/create",
      name: "Criação de movimento de estoque de combustível",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelStock/FuelStockCreateMovement.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/fuelStock/list",
      name: "Lista de estoque de combustível",
      props: true,
      component: () =>
        import("src/pagesRms/fuelSupplies/fuelStock/FuelStockList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/fuelStock/movements/list/:fuelTypeId",
      name: "Movimentações estoque de combustível",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelStockMovements/FuelStockMovementList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path:
        "/checklist/fuelStock/movements/list/:fuelTypeId/:internalGasStation",
      name: "Movimentações estoque de combustível",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelStockMovements/FuelStockMovementList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/gasStation/list/",
      name: "Listagem de postos de gasolina",
      props: true,
      component: () =>
        import("src/pagesRms/fuelSupplies/gasStation/GasStationList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/gasStation/create/",
      name: "Criação de postos de gasolina",
      props: true,
      component: () =>
        import("src/pagesRms/fuelSupplies/gasStation/GasStationCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/gasStation/edit/:id",
      name: "Edição de postos de gasolina",
      props: true,
      component: () =>
        import("src/pagesRms/fuelSupplies/gasStation/GasStationEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/fuelSupplies/formConfiguration",
      name: "Configuração de Formulário de Abastecimento",
      props: true,
      component: () =>
        import(
          "src/pagesRms/fuelSupplies/fuelSupplies/fuelSupplyFormConfiguration/FuelSupplyFormConfiguration.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/revision/entryConfiguration",
      name: "Configuração de Formulário de Entrada de Manutenção",
      props: true,
      component: () =>
        import(
          "@/pagesRms/Vehicles/VehicleRevision/RevisionConfigurations/RevisionEntryConfiguration.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/revision/exitConfiguration",
      name: "Configuração de Formulário de Entrada de Manutenção",
      props: true,
      component: () =>
        import(
          "@/pagesRms/Vehicles/VehicleRevision/RevisionConfigurations/RevisionExitConfiguration.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleRegistration/list/",
      name: "Listagem de equipamentos",
      props: true,
      component: () =>
        import("src/pagesRms/Vehicles/VehicleRegistration/VehicleList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleRegistration/create/",
      name: "Criação de equipamentos",
      props: true,
      component: () =>
        import("src/pagesRms/Vehicles/VehicleRegistration/VehicleCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleRegistration/edit/:id",
      name: "Edição de equipamentos",
      props: true,
      component: () =>
        import("src/pagesRms/Vehicles/VehicleRegistration/VehicleEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleRegistration/import",
      name: "Importar veículos",
      component: () =>
        import("@/pagesRms/Vehicles/VehicleRegistration/VehicleImport.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleRevisionEntry/list",
      name: "Listagem de entradas de Manutenções",
      component: () =>
        import(
          "@/pagesRms/Vehicles/VehicleRevision/List/RevisionEntriesList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleRevisionExit/list",
      name: "Listagem de saída de Manutenções",
      component: () =>
        import("@/pagesRms/Vehicles/VehicleRevision/List/RevisionExitList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleRevisionDone/list",
      name: "Listagem de Manutenções realizadas",
      component: () =>
        import("@/pagesRms/Vehicles/VehicleRevision/List/RevisionDoneList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleRevision/indiceValues",
      name: "Configuração de valores de índice",
      component: () =>
        import("@/pagesRms/Vehicles/VehicleRevision/RevisionIndiceValues.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/sector/all",
      name: "Setores",
      component: () => import("@/pagesRms/System/Sector/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/sector/create",
      name: "Registrar setor",
      props: true,
      component: () => import("@/pagesRms/System/Sector/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/sector/edit/:id",
      name: "Editar setor",
      props: true,
      component: () => import("@/pagesRms/System/Sector/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/costCenter/list/",
      name: "centro de custo",
      component: () =>
        import("@/pagesRms/System/CostCenter/CostCenterList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/costCenter/create/",
      name: "centro de custo",
      component: () =>
        import("@/pagesRms/System/CostCenter/CostCenterCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/costCenter/edit/:id",
      name: "centro de custo",
      component: () =>
        import("@/pagesRms/System/CostCenter/CostCenterEdit.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/brandVehicle/list/",
      name: "Marca de veículos",
      component: () =>
        import("@/pagesRms/System/BrandVehicle/BrandVehicleList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/brandVehicle/create/",
      name: "Marca de veículos",
      component: () =>
        import("@/pagesRms/System/BrandVehicle/BrandVehicleCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/brandVehicle/edit/:id",
      name: "Marca de veículos",
      component: () =>
        import("@/pagesRms/System/BrandVehicle/BrandVehicleEdit.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleModel/list",
      name: "Modelo de veículos",
      component: () =>
        import("@/pagesRms/System/VehicleModel/VehicleModelList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleType/list",
      name: "Modelo de veículos",
      component: () =>
        import("@/pagesRms/Vehicles/VehicleType/VehicleTypeList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleModel/create/",
      name: "Modelo de veículos",
      component: () =>
        import("@/pagesRms/System/VehicleModel/VehicleModelCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleModel/edit/:id",
      name: "Modelo de veículos",
      component: () =>
        import("@/pagesRms/System/VehicleModel/VehicleModelEdit.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleAvailableReason/list",
      name: "Motivo de desativação",
      component: () =>
        import(
          "@/pagesRms/Vehicles/VehicleAvailableReason/VehicleAvailableReasonList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleAvailableReason/create",
      name: "Motivo de desativação",
      component: () =>
        import(
          "@/pagesRms/Vehicles/VehicleAvailableReason/VehicleAvailableReasonCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/vehicleAvailableReason/edit/:id",
      name: "Motivo de desativação",
      component: () =>
        import(
          "@/pagesRms/Vehicles/VehicleAvailableReason/VehicleAvailableReasonEdit.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/sector/all",
      name: "Setores",
      component: () => import("@/pagesRms/System/Sector/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/sector/create",
      name: "Registrar setor",
      props: true,
      component: () => import("@/pagesRms/System/Sector/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/sector/edit/:id",
      name: "Editar setor",
      props: true,
      component: () => import("@/pagesRms/System/Sector/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/chartExemples/",
      name: "Exemplos de gráficos",
      props: true,
      component: () =>
        import("@/pagesRms/checklist/Dashboard/ChartExemples.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/predefinedScript/list",
      name: "Scripts Predefinido",
      component: () =>
        import(
          "@/pagesRms/checklist/PredefinedScripts/PredefinedScriptList.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/fuelSupplyDashboard/",
      name: "Painel de abastecimentos",
      props: true,
      component: () =>
        import("@/pagesRms/checklist/Dashboard/FuelSupplyDashboard.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/fuelSupplyDashboardHorimetro/",
      name: "Painel de abastecimentos Horimetro",
      props: true,
      component: () =>
        import(
          "@/pagesRms/checklist/Dashboard/Horimetro/FuelSupplyDashboardHorimetro.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/fuelSupply/import",
      name: "Importação de Abastecimentos",
      props: true,
      component: () =>
        import(
          "@/pagesRms/fuelSupplies/fuelSupplyImportation/FuelSupplyImport.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/reviewDashboard/",
      name: "Painel de Manutenções",
      props: true,
      component: () =>
        import("@/pagesRms/checklist/Dashboard/ReviewDashboard.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/predefinedScript/create/:id?",
      props: true,
      name: "Scripts Predefinido",
      component: () =>
        import("@/pagesRms/checklist/PredefinedScripts/PredefinedScript.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/predefinedScript/edit/:id",
      props: true,
      name: "Scripts Predefinido",
      component: () =>
        import("@/pagesRms/checklist/PredefinedScripts/PredefinedScript.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/plans/list",
      name: "Planos",
      component: () => import("@/pagesRms/System/Plans/PlanList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/plans/save/:id?",
      name: "Planos",
      props: true,
      component: () => import("@/pagesRms/System/Plans/PlanSave.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/voucher/list",
      name: "Voucher",
      component: () => import("@/pagesRms/System/Vouchers/VoucherInit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/expense/list",
      name: "Listagem de despesas",
      component: () => import("@/pagesRms/expenses/ExpenseList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/expense/save/:id?",
      name: "Despesas",
      props: true,
      component: () => import("@/pagesRms/expenses/ExpenseSave.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/route/list",
      name: "Listagem de rotas",
      component: () => import("@/pagesRms/systemRoutes/RouteList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/route/save/:id?",
      name: "Despesas",
      props: true,
      component: () => import("@/pagesRms/systemRoutes/RouteSave.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/advanceMoney/list",
      name: "Listagem de despesas",
      component: () => import("@/pagesRms/expenses/AdvanceMoneyList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/checklist/advanceMoney/save/:id?",
      name: "Despesas",
      props: true,
      component: () => import("@/pagesRms/expenses/AdvanceMoneySave.vue"),
      meta: {
        requiresAuth: true
      }
    },
  ]
};

let pagesTrackingClient = {
  path: "/",
  component: () => import("@/pagesRms/trackingClient/TrackingClientLayout.vue"),
  name: "TrackingClientLayout",
  children: [
    {
      path: "trackingClient/finished",
      name: "TrackingClientFinished",
      meta: {
        title: "Entregues"
      },
      component: () =>
        import("@/pagesRms/trackingClient/TrackingClientFinished.vue")
    },
    {
      path: "trackingClient/opened",
      name: "TrackingClientOpened",
      meta: {
        title: "Em andamento"
      },
      component: () =>
        import("@/pagesRms/trackingClient/TrackingClientOpened.vue")
    }
  ]
};

let pagesTrackingClientLogin = {
  path: "/",
  component: () =>
    import("@/pagesRms/trackingClient/TrackingClientLoginLayout.vue"),
  name: "TrackingClientLayout",
  children: [
    {
      path: "trackingClient/login",
      name: "TrackingClientLogin",
      component: () =>
        import("@/pagesRms/trackingClient/TrackingClientLogin.vue")
    },
    {
      path: "forgotPassword",
      name: "ForgotPassword",
      component: () => import("@/components_rms/System/User/ForgotPassword.vue")
    }
  ]
};

let pagesShared = {
  path: "/checklist/shared/fill/:SharedFillGuid?",
  name: "Preenchimento de Formulário Comparitlhado",
  component: () =>
    import("src/pagesRms/checklist/checklist/ChecklistSharedFill.vue"),
  props: true,
  meta: {
    requiresAuth: false
  }
};

let pagesSupport = {
  path: "/support/layout/",
  component: () => import("src/pagesRms/support/SupportLayout.vue"),
  name: "SupportLayout",
  children: [
    {
      path: "/support/chat",
      name: "Support chat",
      component: () => import("src/pagesRms/support/SupportChat.vue")
    },
    {
      path: "/support/timeline",
      name: "Support chat timeline",
      component: () => import("src/pagesRms/support/SupportChatTimeline.vue")
    }
  ]
};

let pagestrackingShippingCompany = {
  path: "/trackingShippingCompany/",
  component: () =>
    import(
      "src/pagesRms/trackingShippingCompany/layout/TrackingShippingCompanyLayout.vue"
    ),
  name: "TrackingShippingCompanyLayout",
  children: [
    {
      path: "",
      redirect: "/trackingShippingCompany/cargo/kanban/"
    },
    {
      path: "/trackingShippingCompany/checklist/fill/:ChecklistId?",
      name: "Preenchimento de Formulário",
      component: () =>
        import("src/pagesRms/checklist/checklist/ChecklistFillBackOnSave.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: "/trackingShippingCompany/checklist/filled/details/:id",
      name: "Detalhes do Preenchimento",
      component: () =>
        import("src/pagesRms/checklist/checklist/ChecklistFilledDatails.vue"),
      props: true,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargo/create/",
      name: "Criar carga",
      component: () => import("@/pagesRms/tracking/cargo/CargoCreate.vue")
    },
    {
      path: "/trackingShippingCompany/cargo/edit/:id/",
      name: "Editar carga",
      props: true,
      component: () => import("@/pagesRms/tracking/cargo/CargoEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    // {
    //   path: '/trackingShippingCompany/cargo/kanban/',
    //   name: 'Kanban',
    //   props: true,
    //   component: () => import('@/components_rms/kankan/KanbanBoard.vue'),
    //   meta: {
    //     requiresAuth: true
    //   },
    // },
    {
      path: "/trackingShippingCompany/cargo/kanban/",
      name: "Kanban",
      props: true,
      component: () => import("@/pagesRms/tracking/cargo/CargoKanban.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargo/kanbanEdit/:id/",
      name: "Editar carga",
      props: true,
      component: () => import("@/pagesRms/tracking/cargo/CargoKanbanEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargo/list/",
      name: "Cargas",
      component: () => import("@/pagesRms/tracking/cargo/CargoList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargo/rotogram",
      name: "rotogramas",
      component: () =>
        import(
          "@/components_rms/tracking/cargo/cargoEgLog/CargoCrudRotogram.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargo/rotogram/create",
      name: "rotogramas",
      component: () =>
        import(
          "@/components_rms/tracking/cargo/cargoEgLog/CargoCrudRotogramCreate.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargo/rotogram/edit/:id",
      name: "rotogramas",
      component: () =>
        import(
          "@/components_rms/tracking/cargo/cargoEgLog/CargoCrudRotogramEdit.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargo/importExcel/",
      name: "Cargas",
      component: () =>
        import("@/components_rms/tracking/cargo/CargoImport.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargoExpense/create/:cargoId",
      name: "CargoExpenseCreate",
      props: true,
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/cargoExpense/CargoExpenseCreate.vue"
        ),
      meta: {
        title: "Criação de despesa",
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargoExpense/edit/:id/",
      name: "CargoExpenseEdit",
      props: true,
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/cargoExpense/CargoExpenseEdit.vue"
        ),
      meta: {
        title: "Edição de despesa",
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargoExpense/list/:cargoId",
      name: "CargoExpenseList",
      props: true,
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/cargoExpense/CargoExpenseList.vue"
        ),
      meta: {
        title: "Despesas de cargas",
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargoRotogram/rotogram/:cargoId",
      name: "CargoRotogram",
      props: true,
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/cargoRotogram/CargoRotogram.vue"
        ),
      meta: {
        title: "Rotograma de cargas",
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargoExpense/kanban/",
      name: "Kanban",
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/cargoExpenseKanban/CargoExpenseKanban.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargoExpense/kanban/edit/:id",
      name: "Kanban",
      props: true,
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/cargoExpenseKanban/CargoExpenseKanbanEdit.vue"
        ),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/cargoExpenseOccurrence/create/",
      name: "CargoExpenseOccurrenceCreate",
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/cargoExpenseOccurrence/CargoExpenseOccurrenceCreate.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Criação de ocorrências de despesa"
      }
    },
    {
      path: "/trackingShippingCompany/cargoExpenseOccurrence/edit/:id",
      name: "CargoExpenseOccurrenceEdit",
      props: true,
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/cargoExpenseOccurrence/CargoExpenseOccurrenceEdit.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Edição de ocorrências de despesa"
      }
    },
    {
      path: "/trackingShippingCompany/cargoExpenseOccurrence/list/",
      name: "CargoExpenseOccurrenceCreate",
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/cargoExpenseOccurrence/CargoExpenseOccurrenceList.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Lista de ocorrências de despesa"
      }
    },
    {
      path: "/trackingShippingCompany/nonAttendanceReason/list/",
      name: "nonAttendanceReasonList",
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/nonAttendanceReason/NonAttendanceReasonList.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Lista de motivo de não atendimento"
      }
    },
    {
      path: "/trackingShippingCompany/nonAttendanceReason/create/",
      name: "nonAttendanceReasonCreate",
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/nonAttendanceReason/NonAttendanceReasonCreate.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Criação de motivo de não atendimento"
      }
    },
    {
      path: "/trackingShippingCompany/nonAttendanceReason/edit/:id",
      name: "nonAttendanceReasonEdit",
      props: true,
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/nonAttendanceReason/NonAttendanceReasonEdit.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Edição de motivo de não atendimento"
      }
    },
    {
      path: "/trackingShippingCompany/disapprovedReason/list/",
      name: "disapprovedReasonList",
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/disapprovedReason/DisapprovedReasonList.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Lista de motivo de não atendimento"
      }
    },
    {
      path: "/trackingShippingCompany/disapprovedReason/edit/:id",
      name: "disapprovedReasonEdit",
      props: true,
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/disapprovedReason/DisapprovedReasonEdit.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Edição de motivo reprovação"
      }
    },
    {
      path: "/trackingShippingCompany/disapprovedReason/create/",
      name: "disapprovedReasonCreate",
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/disapprovedReason/DisapprovedReasonCreate.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Criação de motivo de reprovação"
      }
    },
    {
      path: "/trackingShippingCompany/company/bi/:companyId",
      name: "Visualizações BI",
      props: true,
      component: () => import("@/pagesRms/BI/PowerBIView/PowerBIViewList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/company/bicreate/:companyId",
      name: "Criar BI",
      props: true,
      component: () =>
        import("@/pagesRms/BI/PowerBIView/PowerBIViewCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/company/biedit/:id/:companyId",
      name: "Criar BI",
      props: true,
      component: () => import("@/pagesRms/BI/PowerBIView/PowerBIViewEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/company/create",
      name: "Criar empresa",
      component: () => import("@/components/empresa/Create.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/company/edit/:id",
      name: "Editar empresa",
      props: true,
      component: () => import("@/components/empresa/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/company/list",
      name: "Empresas",
      component: () => import("@/components/empresa/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/dashboard/default",
      name: "Dashboard",
      component: () =>
        import("src/pagesRms/trackingShippingCompany/dashboard/Dashboard.vue")
    },
    {
      path: "/trackingShippingCompany/occurrencyFromTo/list",
      name: "Ocorrências de/para",
      component: () => import("@/components/tabelaOcorrenciaDePara/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/occurrenceType/create/",
      name: "OccurrenceTypeCreate",
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/occurrenceType/OccurrenceTypeCreate.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Criação de Ocorrências"
      }
    },
    {
      path: "/trackingShippingCompany/occurrenceType/edit/:id",
      name: "OccurrenceTypeEdit",
      props: true,
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/occurrenceType/OccurrenceTypeEdit.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Edição de Ocorrências"
      }
    },
    {
      path: "/trackingShippingCompany/occurrenceType/list/",
      name: "OccurrenceTypeCreate",
      component: () =>
        import(
          "@/pagesRms/trackingShippingCompany/occurrenceType/OccurrenceTypeList.vue"
        ),
      meta: {
        requiresAuth: true,
        title: "Lista de Ocorrências"
      }
    },
    {
      path: "/trackingShippingCompany/profile/all",
      name: "TrackingShippingCompanyProfilesList",
      component: () => import("src/pagesRms/System/Profile/List.vue"),
      meta: {
        requiresAuth: true,
        title: "Perfis"
      }
    },
    {
      path: "/trackingShippingCompany/profile/create",
      name: "TrackingShippingCompanyProfilesCreate",
      component: () => import("@/pagesRms/System/Profile/Create.vue"),
      meta: {
        requiresAuth: true,
        title: "Criar Perfil"
      }
    },
    {
      path: "/trackingShippingCompany/profile/edit/:id",
      name: "TrackingShippingCompanyProfilesEdit",
      props: true,
      component: () => import("@/pagesRms/System/Profile/Edit.vue"),
      meta: {
        requiresAuth: true,
        title: "Editar Perfil"
      }
    },
    {
      path: "/trackingShippingCompany/user/create/",
      name: "Criar usuário",
      component: () => import("@/components/usuario/Create.vue")
    },
    {
      path: "/trackingShippingCompany/user/edit/:id/",
      name: "Editar usuário",
      props: true,
      component: () => import("@/components/usuario/Edit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/user/list/",
      name: "Usuários",
      component: () => import("@/components/usuario/List.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/user/importUser/",
      name: "Importar usuários",
      component: () => import("@/components/usuario/ImportUser.vue")
      // meta: {
      //   requiresAuth: true
      // }
    },
    {
      path: "/trackingShippingCompany/user/profile/",
      name: "ChecklistUserProfile",
      props: true,
      component: () => import("@/pagesRms/System/User/UserProfile.vue"),
      meta: {
        title: "Perfil do usuário",
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/user/profileEdit/",
      name: "ChecklistUserProfileEdit",
      props: true,
      component: () => import("@/pagesRms/System/User/UserProfileEdit.vue"),
      meta: {
        title: "Editar perfil do usuário",
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/user/changePassword/",
      name: "ChecklistUserProfileChangePassword",
      props: true,
      component: () =>
        import("@/pagesRms/System/User/UserProfileEditPassword.vue"),
      meta: {
        title: "Alterar senha",
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/vehicleType/create/",
      name: "Criar usuário",
      component: () =>
        import("@/pagesRms/tracking/vehicleType/VehicleTypeCreate.vue")
    },
    {
      path: "/trackingShippingCompany/vehicleType/edit/:id/",
      name: "Editar usuário",
      props: true,
      component: () =>
        import("@/pagesRms/tracking/vehicleType/VehicleTypeEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/vehicleType/list/",
      name: "Usuários",
      component: () =>
        import("@/pagesRms/tracking/vehicleType/VehicleTypeList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/module/all",
      name: "Módulos",
      component: () => import("src/pagesRms/System/Module/ModuleList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/module/create",
      name: "Criar Módulo",
      component: () => import("@/pagesRms/System/Module/ModuleCreate.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/module/edit/:id",
      name: "Editar Módulo",
      props: true,
      component: () => import("@/pagesRms/System/Module/ModuleEdit.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/moduleProfile/list/:id",
      name: "Perfis do módulo",
      props: true,
      component: () =>
        import("src/pagesRms/System/Module/ModuleProfileList.vue"),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: "/trackingShippingCompany/moduleMenu/list/:id",
      name: "Menu do módulo",
      props: true,
      component: () => import("src/pagesRms/System/Module/ModuleMenuList.vue"),
      meta: {
        requiresAuth: true
      }
    }
  ]
};

let home = {
  path: "/home",
  name: "Home screen",
  component: () => import("src/homeScreen/app.vue"),
  meta: {
    requiresAuth: true
  }
};
let module = {
  path: "/module",
  name: "Home screen",
  component: () => import("src/homeScreen/ModuleHome.vue"),
  meta: {
    requiresAuth: true
  }
};

let pagesPrivacy = {
  path: "/",
  component: () => import("@/pagesRms/privacy/PrivacyLayout.vue"),
  name: "PrivacyLayout",
  children: [
    {
      path: "privacy",
      name: "PrivacyPage",
      component: () => import("@/pagesRms/privacy/PrivacyPage.vue")
    }
  ]
};

const routes = [
  // {
  //   path: '/',
  //   // redirect: '/home',
  //   name: 'Home'
  // },
  {
    path: "/",
    redirect: "/module",
    name: "Modules"
  },
  empresa,
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  authPages,
  newAuthPages,
  pagesChecklistRMS,
  pagesRmsBI,
  pagesTrackingClient,
  pagesTrackingClientLogin,
  pagesShared,
  pagesSupport,
  pagestrackingShippingCompany,
  pagesRmsModule,
  pagesRmsWorkflow,
  pagesPrivacy,
  home,
  module,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    name: "Dashboard layout",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard },
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "calendar",
        name: "Calendar",
        components: { default: Calendar }
      },
      {
        path: "charts",
        name: "Charts",
        components: { default: Charts }
      },
      {
        path: "widgets",
        name: "Widgets",
        components: { default: Widgets }
      }
    ]
  },
  { path: "*", component: NotFound }
];

export default routes;
